<template>
  <b-row>
    <b-col
      cols="12"
    >
      <validation-provider
        #default="{ errors }"
        :name="(priceKeyNumber + 1) + '. ' + dataList[keyNumber].currency + ' Fiyat'"
        rules="required"
      >
        <b-input-group>
          <b-form-input
            :id="'price' + priceKeyNumber"
            v-model="dataList[keyNumber].prices[priceKeyNumber].price"
            placeholder="Fiyat"
          />
          <b-input-group-append
            is-text
          >
            {{ dataList[keyNumber].currency }}
          </b-input-group-append>
        </b-input-group>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-col>
  </b-row>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BRow, BCol, BInputGroup, BInputGroupAppend, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'PriceItem',
  components: {
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    ValidationProvider,
  },
  props: {
    keyNumber: {
      type: Number,
      required: true,
    },
    priceKeyNumber: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      locale: 'tr',
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['productPrices/dataList']
    },
  },
  created() {
    localize(this.locale)
  },
}
</script>
